import React from "react";

export default function Play() {
  return <i className="fas fa-play" />;
}
